import { IconPropsType } from '..';

export const RocketIcon = ({ ...props }: IconPropsType) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M7.89916 13.9972L6.00277 12.1008V8.94018L11.0598 13.9972H7.89916Z" />
      <path d="M18 2C18 2 12.3241 1.98673 7.89916 6.41165C6.00909 8.30173 6.00277 11.4687 7.26703 12.733C8.53129 13.9972 11.6983 13.9909 13.5884 12.1008C18.0133 7.67591 18 2 18 2ZM11.3333 7.04378C11.3333 6.34528 12.2577 5.46864 12.9562 5.46864C13.6547 5.46864 14.5318 6.34528 14.5318 7.04378C14.5318 7.74229 13.6547 8.66667 12.9562 8.66667C12.2577 8.66667 11.3333 7.74229 11.3333 7.04378Z" />
      <path d="M12.8367 11.896C12.8367 11.896 13.7938 14.5173 12.8367 15.4737C11.4018 16.9086 8.73684 18 8.73684 18L9.16343 12.733L12.8367 11.896Z" />
      <path d="M8.10397 7.16326C8.10397 7.16326 5.48273 6.08674 4.52632 7.04378C3.09138 8.47872 2 11.2632 2 11.2632L7.26703 10.8366L8.10397 7.16326Z" />
      <path d="M7.43188 14.4719C7.3864 14.5366 7.35912 14.6113 7.3005 14.6689C6.31516 15.6538 4.83665 15.1618 4.83665 15.1618C4.83665 15.1618 4.34347 13.6841 5.32982 12.6992C5.38844 12.6406 5.46221 12.6144 5.52689 12.5679L5.06505 12.1053C4.68102 12.2063 4.31619 12.3982 4.01604 12.6982C2.63555 14.078 2.85485 17.1426 2.85485 17.1426C2.85485 17.1426 5.90284 17.38 7.30151 15.982C7.60166 15.682 7.79368 15.3174 7.89474 14.9335L7.43188 14.4719Z" />
    </svg>
  );
};
